/** @format */

import React from "react";
import logo from "../../assets/Logo.png";
import "./loading.css";


export default function Loading() {
  return (
		<div className="fixed  dark:bg-dark-800 top-0 w-full h-screen bg-white z-[500] overflow-hidden grid place-items-center">
			<div className="ring dark:bg-dark-800 dark:text-red-200 ">
				<p className="animation animate-pulse bg">
					<img
						src={logo}
						alt="Trending anime"
						className="w-full h-full object-cover"
					/>
				</p>
				<span></span>
			</div>
		</div>
	);
}
